import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MedIconsModule } from "@mk/med-icons";

import { MedUploadFileComponent } from "./med-upload-file.component";
import { MedLabelModule } from "../med-label/med-label.module";

@NgModule({
  declarations: [
    MedUploadFileComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedLabelModule,
    MedIconsModule,
  ],
  exports: [
    MedUploadFileComponent,
  ],
})
export class MedUploadFileModule { }
